import {gsap} from "gsap";
import {isMobile, isTablet} from "../components/helpers";
import {ScrollTrigger} from "gsap/ScrollTrigger";

export function initBitrixLanding() {
    if (!$('#bitrix_landing').length) return;
    gsap.registerPlugin(ScrollTrigger);

    let $circleWrapper = $('.project-video-wrapper.hide-only-mobile');
    let firstCircle = $circleWrapper.find('.circle-1');
    let secondCircle = $circleWrapper.find('.circle-2');
    let bigCircle = $circleWrapper.find('.big-circle');


    let tl1 = gsap.timeline({ repeat: -1 })
        tl1.to(firstCircle,  { duration: 5, y: 20,ease: "Power1.ease" })
        tl1.to(firstCircle,  { duration: 4, y: 0,ease: "Power1.ease" })

    let tl2 = gsap.timeline({ repeat: -1 })
        tl2.to(secondCircle,  { duration: 4, y: -20 })
        tl2.to(secondCircle,  { duration: 3, y: 0 })

    let tl3 = gsap.timeline({ repeat: -1 })
        tl3.to(bigCircle,{ duration: 2, y: 10 })
        tl3.to(bigCircle,{ duration: 2,y: 0})

    if(isMobile()){
        let $circleWrapper = $('.mobile-main');
        let firstCircle = $circleWrapper.find('.circle-1');
        let secondCircle = $circleWrapper.find('.circle-2');
        let bigCircle = $circleWrapper.find('.big-circle');


        let tl1 = gsap.timeline({ repeat: -1 })
        tl1.to(firstCircle,  { duration: 5, y: 20,ease: "Power1.ease" })
        tl1.to(firstCircle,  { duration: 4, y: 0,ease: "Power1.ease" })

        let tl2 = gsap.timeline({ repeat: -1 })
        tl2.to(secondCircle,  { duration: 4, y: -20 })
        tl2.to(secondCircle,  { duration: 3, y: 0 })

        let tl3 = gsap.timeline({ repeat: -1 })
        tl3.to(bigCircle,{ duration: 2, y: 10 })
        tl3.to(bigCircle,{ duration: 2,y: 0})
    }


    const $handTrigger = $('.bitrix-hand-section');
    gsap
        .fromTo('.iphone-hand-wrapper.bitrix', {
            scrollTrigger: {
                trigger: $handTrigger,
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: () => 'center bottom',
            },
            rotate: 90,
            duration : .6,
            transformOrigin:"left bottom"
        }, {
            scrollTrigger: {
                trigger: $handTrigger,
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: () => 'center bottom',
            },
            rotate: 0,
            duration : .6,
            transformOrigin:"left bottom"
        });
}
